import { EmployeeAvatar } from "@/components/employee/EmployeeAvatar.tsx";
import { getUIKitColorHSLA } from "@/helpers/style.helper.ts";
import useFormatter from "@/hooks/use-formatter.hook.ts";
import { EmployeePersonalCard } from "@/pages/employees/employee/components/EmployeePersonalCard.tsx";
import { useEmployeeDetails } from "@/queries/employees/use-employees.query.ts";
import { ApiEmployee } from "@/types/employees/employee.types.ts";
import { EmojiDisplay, Skeleton, Stack, Tag, Title, toCssColorValue } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface EmployeeViewContentProps {
  employee?: ApiEmployee;
  employeeId?: number;
}

export function EmployeeViewContent({ employee, employeeId }: EmployeeViewContentProps) {
  const { t } = useTranslation();
  const { renderEmployeeName, renderShortDate } = useFormatter();

  const resolvedId = employeeId ?? employee?.id;
  const { data: employeeLoaded } = useEmployeeDetails(resolvedId, !!resolvedId);

  const employeeToUse = employeeLoaded;

  return (
    <Stack gap={"lg"}>
      {employeeToUse && (
        <>
          <Stack items={"center"} gap={"lg"}>
            <Stack items={"center"} gap={"smd"}>
              <EmployeeAvatar size={"2xl"} employee={employeeToUse} />
              <Title header={renderEmployeeName(employeeToUse)} size={"lg"} />
            </Stack>
            {employeeToUse.time_off && (
              <Tag
                className={"gap-1"}
                borderColor={toCssColorValue(
                  employeeToUse.time_off.category.color,
                  getUIKitColorHSLA("brand-dark", 0.2)
                )}
                color={toCssColorValue(
                  employeeToUse.time_off.category.color,
                  getUIKitColorHSLA("brand-dark", 1)
                )}
              >
                <EmojiDisplay id={employeeToUse.time_off.category.emoji} size={"sm"} />
                {`${employeeToUse.time_off.category.title} ${t("common:till")} ${renderShortDate(employeeToUse.time_off.date_to)}`}
              </Tag>
            )}
          </Stack>
          <EmployeePersonalCard employee={employeeToUse} openLinksInNewTab={true} />
        </>
      )}

      {!employeeToUse && <Skeleton className="w-full h-4" />}
    </Stack>
  );
}
